import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {PointModel} from '../models/point.model';
import {CoordinatesModel} from "../models/coordinates.model";

const GEOLOCATION_ERRORS = [
  'Browser does not support location services',
  'You have rejected access to your location',
  'Unable to determine your location',
  'Service timeout has been reached'
];

@Injectable()
export class GeoLocationService {

  public getLocation(): Observable<CoordinatesModel> {
    return Observable.create(observer => {
      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(new CoordinatesModel({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              accuracy: position.coords.accuracy
            }));
            observer.complete();
          },
          (error) => {
            alert(GEOLOCATION_ERRORS[+error.code]);
            return observer.error(GEOLOCATION_ERRORS[+error.code])
          });
      } else {
        observer.error(GEOLOCATION_ERRORS[0]);
      }
    });


  }

}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/services/geoLocation.service.ts